export default __webpack_public_path__ + "static/media/check_on.69fafa84.svg";